import React, {FC} from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import styles from './AppLoader.module.scss';

interface IProps {
    loaderText?: string;
    customLoader?: boolean;
}

const AppLoaderContent: FC<IProps> = ({loaderText, customLoader}) => {
    const localizedStrings = getLocalizedStrings();
    const appLoaderClassName = customLoader ? styles.AppCustomLoader : styles.AppLoader;

    return (
        <>
            <div className={appLoaderClassName} data-testid={elementsTesIds.LOADER_CONTROL}>
                <div />
                <div />
                <div />
                <div />
            </div>
            {!customLoader && (
                <div className={styles.LoaderMessage}>
                    {loaderText !== undefined
                        ? loaderText
                        : localizedStrings && (
                              <p
                                  className={styles.TextMain}
                                  dangerouslySetInnerHTML={{
                                      __html: localizedStrings[localizationKeys.GLOBAL_LOADER_DEFAULT_TEXT],
                                  }}
                              />
                          )}
                </div>
            )}
        </>
    );
};

export default AppLoaderContent;
